import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Grid } from "semantic-ui-react";

import * as util from "../../shared/utility";
import * as actions from "../../actions";
import TrelloPersonForm from "./TrelloPersonForm";
import StandardTableHeader from "../UI/StandardHeader";

const TrelloPersonCreate = ({
  match: {
    params: { personid },
  },
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.fetchTrelloPerson(personid));
    dispatch(actions.fetchFiles());

    return () => {
      dispatch(actions.unloadTrelloPerson());
    };
  }, []);

  const [searchValue, setSearchValue] = useState("");

  const persondata = useSelector((state) => state.trellos.person);
  const creating = useSelector((state) => state.trellos.creating);
  const responsemessage = useSelector((state) => state.trellos.responsemessage);
  const showmessage = useSelector((state) => state.trellos.showmessage);
  const files = useSelector((state) => state.files.items);
  const projectFiles = useSelector((state) => state.projectFiles.items);

  const projectid =
    persondata && persondata.projectID ? persondata.projectID : null;

  const onSubmit = (fv) => {
    dispatch(actions.createTrelloPerson(fv));
  };

  if (!personid || !projectid) {
    return <div>No valid personid...</div>;
  }

  const init = {
    contactText:
      persondata.contactPerson &&
      persondata.contactPerson.fullName +
        " (" +
        persondata.contactPerson.title +
        ")",
    emailText: persondata.contactPerson && persondata.contactPerson.email,
    phoneText: persondata.contactPerson && persondata.contactPerson.phoneNumber,
    addressText:
      persondata.projectAddress &&
      persondata.projectAddress.fullAddress +
        (persondata.projectAddress.zipCode
          ? ", " + persondata.projectAddress.zipCode
          : "") +
        (persondata.projectAddress.city
          ? ", " + persondata.projectAddress.city
          : ""),
    projectText: persondata.name,
    visitText:
      persondata.visit &&
      util.utcStringToDutchDate(persondata.visit.visitDateTime) +
        (persondata.visit.visitorName
          ? " (" + persondata.visit.visitorName + ")"
          : ""),
    ...persondata,
  };

  return (
    <React.Fragment>
      <Grid>
        <Grid.Row>
          <Grid.Column>
            <StandardTableHeader headerLabel="Send User To Trello"></StandardTableHeader>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <h4>Person: {persondata.name}</h4>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <TrelloPersonForm
              enableReinitialize={true}
              initialValues={init}
              onSubmit={onSubmit}
              files={files}
              projectFiles={projectFiles}
              downloadFile={(filename) =>
                dispatch(actions.downloadFile(filename))
              }
              downloadProjectFile={(projectid, filename) =>
                dispatch(actions.downloadProjectFile(projectid, filename))
              }
              showmessage={showmessage}
              resetTrelloMessage={() => dispatch(actions.resetTrelloMessage())}
              responsemessage={responsemessage}
              projectid={projectid}
              searchValue={searchValue}
              updatesearchValue={(evt) => setSearchValue(evt.target.value)}
              creating={creating}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </React.Fragment>
  );
};

export default TrelloPersonCreate;
